import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {
  LoginModel,
  RecoverPasswordModel,
  ResetPasswordModel,
  ServerResponse,
  UserLogged,
} from '@models';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public userStatus: Subject<boolean> = new Subject<boolean>();

  constructor(private readonly http: HttpClient) {}

  /**
   * Change user status when their personal information change
   * @param status user status
   */
  public setUserStatus(status: boolean): void {
    this.userStatus.next(status);
  }

  public login(data: LoginModel): Observable<ServerResponse> {
    return this.http.post<ServerResponse>(environment.LOGIN, data);
  }

  public logout(): Observable<{}> {
    return this.http.delete(environment.LOGOUT);
  }

  public recoverPassword(data: RecoverPasswordModel): Observable<{}> {
    return this.http.post(environment.RECOVER_PASSWORD, data);
  }

  public resetPassword(data: ResetPasswordModel): Observable<{}> {
    return this.http.patch(environment.RECOVER_PASSWORD, data);
  }

  public userRol(): string {
    const user = JSON.parse(localStorage.getItem('user'));

    return user?.application;
  }

  public getUser(): UserLogged {
    return JSON.parse(localStorage.getItem('user'));
  }

  public setUser(userData?: UserLogged): void {
    localStorage.setItem('user', JSON.stringify(userData));
  }

  public removeUser(): void {
    return localStorage.removeItem('user');
  }
}
